import { REHYDRATE_MODULE_SCHEMAS_SUCCEEDED, FETCH_MODULE_SCHEMAS_SUCCEEDED, FETCH_CONTENT_SCHEMA_SUCCEEDED, BATCH_FETCH_MODULE_SCHEMAS_SUCCEEDED, ADD_TO_BUILT_IN_MAPPING, UPDATE_HEADER, UPDATE_FOOTER } from 'ContentEditorUI/redux/actions/actionTypes';
import { combineModuleSchemas, rehydrateModuleSchemasWithTranslations } from 'ContentEditorUI/data/ModuleTransforms';
export const moduleSchemasInitialState = {
  all: {},
  allAddable: {},
  builtinMapping: {},
  builtInModules: {},
  categoryName: null,
  customModules: {},
  globalModules: {},
  globalGroupInfo: {},
  globalPartialInfo: {},
  headerInfo: {},
  footerInfo: {}
};
const moduleSchemaReducer = (state = moduleSchemasInitialState, data = {
  type: '',
  response: {}
}) => {
  const {
    type,
    response
  } = data;
  switch (type) {
    case REHYDRATE_MODULE_SCHEMAS_SUCCEEDED:
      return rehydrateModuleSchemasWithTranslations(response, state);
    case FETCH_MODULE_SCHEMAS_SUCCEEDED:
    case BATCH_FETCH_MODULE_SCHEMAS_SUCCEEDED:
      return combineModuleSchemas(Object.assign({
        existingAllModulesMap: state.all,
        existingAllAddableMap: state.allAddable,
        existingBuiltInModulesMap: state.builtInModules,
        existingGlobalModulesMap: state.globalModules,
        existingCustomModulesMap: state.customModules
      }, response), state);
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const contentSchemaResponse = response;
        const {
          used_module_schemas: usedModuleSchemas
        } = contentSchemaResponse;
        if (usedModuleSchemas && Object.keys(usedModuleSchemas).length) {
          let categoryName = state.categoryName;
          if (!categoryName) {
            categoryName = contentSchemaResponse.categoryName;
            state = Object.assign({}, state, {
              categoryName
            });
          }
          state = combineModuleSchemas({
            categoryName,
            usedModuleSchemas,
            existingAllModulesMap: state.all,
            existingAllAddableMap: state.allAddable,
            existingBuiltInModulesMap: state.builtInModules,
            existingGlobalModulesMap: state.globalModules,
            existingCustomModulesMap: state.customModules,
            canAddToAddableMap: false
          }, state);
        }
        return Object.assign({}, state, {
          builtinMapping: contentSchemaResponse.builtin_mapping,
          globalGroupInfo: contentSchemaResponse.schema.global_group_info_by_path,
          globalPartialInfo: contentSchemaResponse.schema.global_partial_info_by_path,
          headerInfo: contentSchemaResponse.schema.header_info || {},
          footerInfo: contentSchemaResponse.schema.footer_info || {}
        });
      }
    case ADD_TO_BUILT_IN_MAPPING:
      {
        return Object.assign({}, state, {
          builtinMapping: Object.assign({}, state.builtinMapping, response)
        });
      }
    case UPDATE_HEADER:
      {
        const {
          payload: {
            templatePath,
            variantName
          }
        } = data;
        return Object.assign({}, state, {
          headerInfo: Object.assign({}, state.headerInfo, {
            [templatePath]: {
              path: templatePath,
              variantName
            }
          })
        });
      }
    case UPDATE_FOOTER:
      {
        const {
          payload: {
            path,
            variantName
          }
        } = data;
        return Object.assign({}, state, {
          footerInfo: Object.assign({}, state.footerInfo, {
            [path]: {
              path,
              variantName
            }
          })
        });
      }
    default:
      return state;
  }
};
export default moduleSchemaReducer;